
import Description from '../../components/Description/Description';
import PagesFooter from '../../components/PagesFooter/PagesFooter';
import PagesHeader from '../../components/PagesHeader/PagesHeader';
import Title from '../../components/Title/Title';
import { usePagesContext } from '../../context/PagesContext';
import useDefaultPagesAction from '../../hooks/useDefaultPagesAction';
import useSetBannerType from '../../hooks/useSetBannerType';
import useTranslation from '../../hooks/useTranslation';

const HowToGetOfferPage = () => {
    const translate = useTranslation();
    const { currentPage } = usePagesContext();
    const defaultPagesAction = useDefaultPagesAction();
    useSetBannerType('bannerZero');

    return (
        <>
            <PagesHeader
                actions={['back']}
                onAction={defaultPagesAction}
                currentPage={currentPage}
                currentSection={0}
                numberOfSections={3}
                numberOfPagesInSection={0}
                currentPageInSection={0}
                sectionTitle={translate('field.section.sbl')}
            />
            <Title text={translate('page.how-to-apply.title')} />
            <Description text={translate('page.how-to-apply-draft.description')} />
            <PagesFooter
                actions={['next']}
                onAction={defaultPagesAction}
                currentSection={0}
                numberOfSections={3}
                numberOfPagesInSection={0}
                currentPageInSection={0}
                sectionTitle={translate('field.section.sbl')}
            />
        </>
    );
};

export default HowToGetOfferPage;
